/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

import moduleAuth from './auth/moduleAuth'
import common from './common/moduleCommon'
import naturalEntity from './naturalEntity/moduleNaturalEntity'
import legalEntity from './legalEntity/moduleLegalEntity'

import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import moduleDataAccess from './dataAccess/moduleDataAccess'

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    auth: moduleAuth,
    common,
    naturalEntity,
    legalEntity,
    app,
    appConfig,
    verticalMenu,
    dataAccess: moduleDataAccess,
  },
  strict: process.env.NODE_ENV !== 'production'
})
